import type { Effect } from '../store/types';

export function effectToCssFilter(e: Effect): string {
  switch (e.kind) {
    case 'none':
      return 'none';
    case 'blur':
      return `blur(${Math.round(e.px)}px)`;
    case 'grayscale':
      return `grayscale(${clamp01(e.amt)})`;
    case 'chromatic': {
      const i = clamp01(e.offset / 4);
      return `saturate(${1 + i * 2}) hue-rotate(${i * 30}deg)`;
    }
    case 'glow':
      return `drop-shadow(0 0 ${Math.round(e.radius)}px ${e.color})`;
    case 'outline':
      return `drop-shadow(0 0 ${Math.round(e.width)}px ${e.color})`;
    case 'crt': {
      const i = clamp01(e.intensity);
      return `contrast(${1 + i * 0.5}) saturate(${1 + i * 0.8}) brightness(${1 - i * 0.1})`;
    }
    case 'frostedGlass':
      return `blur(${Math.round(e.blur)}px)`;
  }
}

function clamp01(n: number): number {
  return Math.max(0, Math.min(1, n));
}
